import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Text,
  type useDisclosure
} from "@chakra-ui/react"
import React from "react"

interface ConfirmDialogProps {
  mainActionText?: string
  title?: string
  body?: string
  mainActionCallBack: () => void
  isOpen: ReturnType<typeof useDisclosure>["isOpen"]
  onClose: ReturnType<typeof useDisclosure>["onClose"]
}
export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  mainActionText = "Confirm",
  mainActionCallBack,
  isOpen,
  title,
  onClose,
  body
}): JSX.Element => {
  const cancelRef = React.useRef(null)

  return (
    <>
      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent bg="accent" color="white" w="240px">
            <AlertDialogCloseButton />
            {title && <AlertDialogHeader>{title}</AlertDialogHeader>}
            <AlertDialogBody {...(!title && { pt: "34px" })} px="16px">
              <Text variant="RBodyBold" textAlign="center">
                {body}
              </Text>
            </AlertDialogBody>

            <AlertDialogFooter justifyContent="center">
              <Button ref={cancelRef} onClick={onClose} variant="linkButton" color="white" fontWeight="normal" fontSize="12px">
                Cancel
              </Button>
              <Button
                onClick={mainActionCallBack}
                ml={3}
                px="18px"
                py="5px"
                lineHeight="19px"
                h="auto"
                fontFamily="Work Sans"
                bg="white"
                color="primary"
                fontWeight="500"
                fontSize={"12px"}
              >
                {mainActionText}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
